import { Label } from "client/CommonComponents";
import './ExceptionErrorLogsPopup.scss'


const ExceptionErrorLogsPopup = (props: any) => {

    const {exceptionErrorLogDetails,dateValue} = props
    return(
        <>
        <div className='error-modal-popup'>
            <Label data-attribute="ExceptionErrorLogsPopup_Default_Label">Error Type</Label>
            <p>{exceptionErrorLogDetails?.errorType}</p>
            <Label data-attribute="ExceptionErrorLogsPopup_Default_Label_2">Error Message</Label>
            <p>{exceptionErrorLogDetails?.errorMessage}</p>
            <Label data-attribute="ExceptionErrorLogsPopup_Default_Label_3">Error Description</Label>
            <p>{exceptionErrorLogDetails?.errorDescription}</p>
            <Label data-attribute="ExceptionErrorLogsPopup_Default_Label_4">Application Type</Label>
            <p>{exceptionErrorLogDetails?.applicationType}</p>
            <Label data-attribute="ExceptionErrorLogsPopup_Default_Label_5">Application</Label>
            <p>{exceptionErrorLogDetails?.isReact ? "React":"API"}</p>
            <Label data-attribute="ExceptionErrorLogsPopup_Default_Label_6">Created Date</Label>
            <p>{dateValue.toLocaleString()}</p>
        </div>        
        </>
    )
}

export default ExceptionErrorLogsPopup;